import React from 'react';
import { useState, useContext } from 'react';
import { Routes, Route, useNavigate } from 'react-router';
import AuthContext from './context/AuthContext';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import LeafletMapContainer from './components/MapContainer';
import LoadingPopup from './components/LoadingPopup';
import RightSidebar from './components/RightSidebar';
import Login from './components/Login';
import Register from './components/Register';
import MyPlans from './components/MyPlans';
import LandingPage from './components/LandingPage';
import UserProfile from './components/UserProfile';
import './App.css';



const extractPointsOfInterest = (planData) => {
  if (!planData || !planData.itinerary) {
    return [];
  }

  const allPois = [];

  planData.itinerary.forEach(dayItem => {

    if (dayItem.activities) {

      dayItem.activities.forEach((activity, index) => {

        if (activity.coordinates) {
          const coordParts = activity.coordinates.split(',');

          if (coordParts.length === 2) {
            const lat = parseFloat(coordParts[0].trim());
            const lng = parseFloat(coordParts[1].trim());

            if (!isNaN(lat) && !isNaN(lng)) {
              allPois.push({
                id: `day-${dayItem.day}-${index}`,
                name: activity.name,
                position: [lat, lng],
                description: activity.description
              });
            }
          }
        }
      });
    }
  });
  return allPois;
};


const MainPage = ({
  handleGeneratePlan,
  isLoading,
  pointsOfInterest,
  planResult,
  handleClearMap,
  activePoiId,
  onSelectPoi
}) => (
  <main className='main-content'>
    <Sidebar onGenerate={handleGeneratePlan} isLoading={isLoading} onClear={handleClearMap} />
    <div className='map-area'>
      <LeafletMapContainer
        pois={pointsOfInterest}
        activePoiId={activePoiId}
      />
    </div>
    <div>
      <RightSidebar
        plan={planResult}
        onSelectPoi={onSelectPoi}
        activePoiId={activePoiId}
      />
    </div>
  </main>
);




function App() {

  const [pointsOfInterest, setPointsOfInterest] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [planResult, setPlanResult] = useState(null);
  const [activePoiId, setActivePoiId] = useState(null);
  const { auth, refreshUser } = useContext(AuthContext);
  const navigate = useNavigate();


  const handleSelectPoi = (poiId) => {
    console.log("App: Setting active POI ID to:", poiId);
    setActivePoiId(poiId);
  };


  const handleGeneratePlan = async (selections) => {
    if (!auth.token) {
      navigate('/login');
      return;
    }

    setIsLoading(true);
    setPointsOfInterest([]);
    setPlanResult(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/generate-plan`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.token}`
        },
        body: JSON.stringify(selections),
      });

      if (!response.ok) {
        const errData = await response.json();

        console.error('Blad generowania planu:', errData.message);

        setIsLoading(false);

        alert(errData.message || 'Blad generowania planu');

        return;
      }

      const { planId, remainingPoints } = await response.json();

      refreshUser();

      if (!planId) {
        throw new Error('Nie otrzymano ID planu od serwera');
      };

      const poll = setInterval(async () => {
        const resultResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/plan-result/${planId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth.token}`
          }
        });
        const resultData = await resultResponse.json();

        if (resultData.status === 'completed') {
          clearInterval(poll);
          setIsLoading(false);

          const finalPlan = resultData.plan.planData;

          const points = extractPointsOfInterest(finalPlan);
          setPointsOfInterest(points);

          setPlanResult(finalPlan);
        }
        refreshUser();
      }, 5000);

    } catch (error) {
      setIsLoading(false);
      console.error(`Error while generating plan:`, error);
      refreshUser();
      alert('An error occurred while generating the plan.');
    }
  };

  const handleClearMap = () => {
    setPointsOfInterest([]);
    setPlanResult("");
    setActivePoiId(null);
  };

  return (
    <div className='app-container'>
      {isLoading && <LoadingPopup />}
      <Header />
      <Routes>
        <Route path="/" element={<LandingPage />} />

        <Route path="/creator" element={
          <MainPage
            handleGeneratePlan={handleGeneratePlan}
            handleClearMap={handleClearMap}
            isLoading={isLoading}
            pointsOfInterest={pointsOfInterest}
            planResult={planResult}
            activePoiId={activePoiId}
            onSelectPoi={handleSelectPoi}
          />
        } />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/my_plans" element={<MyPlans />} />
        <Route path="/profile" element={<UserProfile />} />
      </Routes>
    </div>
  );
};

export default App;
